export default __webpack_public_path__ + "static/media/GIF_Placeholder.920afb28.png";